import { DynamicObjectInterface } from '../type';
import { AxiosUtilsType, axiosPost } from './axiosUtils';
import './axiosInterceptor';

const ValidationService = {
  async validateOrderNumber(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`orderValidation`, payload);
  },

  async validatePromoOrder(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`promoOrderValidation`, payload);
  },
};
export default ValidationService;
